import {
  TypedUseSelectorHook,
  useSelector as nativeUseSelector,
} from "react-redux";
import { RootState } from "../store";

export const useSelector: TypedUseSelectorHook<RootState> = nativeUseSelector;
